import { ROUTES } from "../shared/utils";

import { ProtectedRoute } from "../shared/pages";

import { AppLayout } from "../shared/layouts";
import { HomeLayout } from "../shared/layouts/HomeLayout";

import { RouteLoader } from "../shared/components";
import { Suspense, lazy } from "react";

const Dashboard = lazy(() => import("../features/dashboard").then((m) => ({ default: m.Dashboard })));
const ProgrammeDashboard = lazy(() => import("../features/programmeDashboard").then((m) => ({ default: m.ProgrammeDashboard })));
const Geospatial = lazy(() => import("../features/geospatial").then((m) => ({ default: m.Geospatial })));
const GeospatialProjects = lazy(() => import("../features/geospatialProjects").then((m) => ({ default: m.GeospatialProjects })));
const InvestmentOversight = lazy(() => import("../features/investmentOversight").then((m) => ({ default: m.InvestmentOversight })));
const ForecastVariance = lazy(() => import("../features/forecastVariance").then((m) => ({ default: m.ForecastVariance })));

export const homeRoutes = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <HomeLayout title="Home" />,
        children: [{ path: ROUTES.DASHBOARD, element: ( <Suspense fallback={<RouteLoader />}> <Dashboard /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Programme Dashboard" />,
        children: [{ path: ROUTES.PROGRAMME_DASHBOARD, element: ( <Suspense fallback={<RouteLoader />}> <ProgrammeDashboard /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Portfolio Dashboard" />,
        children: [{ path: ROUTES.INVESTMENT_OVERSIGHT, element: ( <Suspense fallback={<RouteLoader />}> <InvestmentOversight /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Forecast Variance" />,
        children: [{ path: ROUTES.FORECAST_VARIANCE, element: ( <Suspense fallback={<RouteLoader />}> <ForecastVariance /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Geospatial Dashboard" />,
        children: [{ path: ROUTES.GEOSPATIAL, element: ( <Suspense fallback={<RouteLoader />}> <Geospatial /> </Suspense>) }],
      },
      {
        element: <AppLayout title="Geospatial Projects" />,
        children: [{ path: ROUTES.GEOSPATIAL_PROJECTS, element: ( <Suspense fallback={<RouteLoader />}> <GeospatialProjects /> </Suspense>) }],
      }
    ],
  },
];
